import { FC, useMemo } from "react";
import { scoreToDisplayStars } from "../../../config/rating";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";
import { resolveWidgetV2Style } from "./widgetV2Styles";

/** Email Signature (v2) — admin-preview-only. Real embed markup lives in widget-v2.js (renderSignature). */
const WidgetTemplate26: FC<IWidgetTemplate> = ({ company, score, style }) => {
  const companyId = company?.companyId;
  const resolvedStyle = resolveWidgetV2Style("signature", style);
  const payload = useMemo(() => ({ companyId, widgetId: 26 as const }), [companyId]);
  const profileUrl = useMemo(
    () => `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=dom&utm_campaign=widget-v2-signature`,
    [companyId],
  );
  const starsValue = scoreToDisplayStars(score?.score ?? 0);

  const body = (
    <>
      Rated <b style={{ color: "#1c1c2e" }}>{starsValue}/5</b> on{" "}
      <b style={{ color: "#006bf1" }}>TrustFinance</b> · {score?.totalReview} verified reviews
    </>
  );

  return (
    <div className="d-flex justify-content-center">
      <a
        href={profileUrl}
        target="_blank"
        rel="noopener"
        onClick={() => ReachClick(payload)}
        style={{
          display: "inline-block",
          borderLeft: resolvedStyle === "one-line" ? "none" : "2px solid #006bf1",
          paddingLeft: resolvedStyle === "one-line" ? 0 : 10,
          fontSize: 12,
          color: "#6b6b85",
          textDecoration: "none",
        }}
      >
        {body}
      </a>
    </div>
  );
};

export default WidgetTemplate26;
